<template>
  <div class="d-flex">
    <div class="icon">{{ iconLetter }}</div>
    <div class="info">
      <div>{{ partnerName }}</div>
      <div class="contact-person-name">{{ contactPersonName }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TableUserItem',
  props: {
    partnerName: {
      type: String
    },
    contactPersonName: {
      type: String
    }
  },
  computed: {
    iconLetter () {
      return this.partnerName.charAt(0)
    }
  }
}
</script>

<style lang="scss" scoped>
.icon {
  width: 33px;
  height: 33px;
  background-color: #DEEBFF;
  border-radius: 50%;
  margin-right: 10px;

  display: flex;
  align-items: center;
  justify-content: center;
  color: #0C56AB;
  font: 700 14px/18px $font-family-second;
}

.info {
  max-width: 130px;

  & > div {
    width: 100%;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
}

.contact-person-name {
  font-size: 11px;
  color: $tableTextHeadColor;
}
</style>
